module.exports = __webpack_public_path__ + "a9f0a13274546baf2a414bf0e1d0d0c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/covers/event.png
// module id = 639
// module chunks = 4